import { render, staticRenderFns } from "./Madd.vue?vue&type=template&id=bf6527dc&scoped=true"
import script from "./Madd.vue?vue&type=script&lang=js"
export * from "./Madd.vue?vue&type=script&lang=js"
import style0 from "./Madd.vue?vue&type=style&index=0&id=bf6527dc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf6527dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf6527dc')) {
      api.createRecord('bf6527dc', component.options)
    } else {
      api.reload('bf6527dc', component.options)
    }
    module.hot.accept("./Madd.vue?vue&type=template&id=bf6527dc&scoped=true", function () {
      api.rerender('bf6527dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Sector/Post/Card/Madd.vue"
export default component.exports